import { render, staticRenderFns } from "./RowQA.vue?vue&type=template&id=82ea9c0a"
import script from "./RowQA.vue?vue&type=script&lang=js"
export * from "./RowQA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports